import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetWithholdingListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    startDateStart: string | undefined
    startDateEnd: string | undefined
    endDateStart: string | undefined
    endDateEnd: string | undefined
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetWithholdingListPagingAndFilterRequest: GetWithholdingListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    endDateEnd: undefined,
    endDateStart: undefined,
    startDateEnd: undefined,
    startDateStart: undefined,
    columnFilters: []
}